













































import { Component } from 'vue-property-decorator';

import flagKeys from '@/constants/flagKeys';

import BillingModel from '@/views/Models/BillingModel.vue';

import CoinsIcon from '@/components/icons/Coins.vue';
import Page from '@/componentsV2/molecules/Page/Page.vue';
import ModalOptions from '@/components/Modal/ModalOptions';
import BillingNetworkTag from '@/componentsV2/atoms/BillingNetworkTag/BillingNetworkTag.vue';
import CoinsOverviewGrid from '@/componentsV2/templates/CoinsOverviewGrid/CoinsOverviewGrid.vue';
import { setUpSellCoins } from '@/utils/sellCoinsUtils';
import { AnalyticsCardListItem } from '@/componentsV2/organisms/AnalyticsCardList/AnalyticsCardList.vue';
import SellCoinsPurchaseHistory from '@/componentsV2/templates/SellCoinsPurchaseHistoryV2/SellCoinsPurchaseHistory.vue';
import YourEarnings, {
  EYourEarningsGroupByLabel
} from '@/componentsV2/templates/YourEarnings/YourEarnings.vue';
import SellCoinsEmptyState from '@/componentsV2/organisms/SellCoins/SellCoinsEmptyState.vue';

import BusinessWalletService from '@/api/BusinessWalletService';
import { BusinessWalletDashboard } from '@/api/interfaces/business-wallet-dashboard.interface';
import { EYourEarningsGroupByOption } from '@/api/BusinessWalletService';
import SellCoinsService from '@/api/SellCoinsService';

import eventBus from '@/utils/eventBus';
import DateUtils from '@/utils/DateUtils';
import { getDataOptional } from '@/utils/dashboardUtils';
import PerformanceUtils, {
  DatePickerShortcut,
  EPeriodPerformance
} from '@/utils/PerformanceUtils';
import { EAnalyticsCardArrowDirection } from '@/componentsV2/molecules/AnalyticsCard/AnalyticsCard.vue';
import { IChartSerie } from '@/models/performance';
import { IPeriod } from '@/models/period';
import { abbreviateNumber } from '@/utils/currency';

import { EBillingStatusTypes } from '@/store/modules/businessTypes';
import { ALREADY_ACCESSED_SELL_COINS } from '../V2/SellCoins.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import { isRemoteLoading } from '@/utils/remote-loading';
import segmentIo from '@/utils/segment.io';
import { EBusinessUserType } from '@/store/modules/businessTypes';

const earningsGraphsOptions = {
  accumulated: {
    slug: EYourEarningsGroupByOption.ACCUMULATE,
    label: EYourEarningsGroupByLabel.ACCUMULATE,
    index: 0,
    loaded: false,
    data: []
  },
  overtime: {
    slug: EYourEarningsGroupByOption.OVERTIME,
    label: EYourEarningsGroupByLabel.OVERTIME,
    index: 1,
    loaded: false,
    data: []
  }
};

@Component({
  components: {
    Page,
    BillingNetworkTag,
    CoinsIcon,
    CoinsOverviewGrid,
    SellCoinsPurchaseHistory,
    YourEarnings,
    SellCoinsEmptyState,
    Typography
  }
})
export default class RevenueReports extends BillingModel {
  loadingDashboardData = false;
  loading = false;
  showEmptyState = false;
  dashboardData: BusinessWalletDashboard | null = null;
  businessWalletService = new BusinessWalletService();

  yourEarningsLoading = false;
  yourEarningsFirstLoading = true;
  yourEarningsPeriod = PerformanceUtils.defaultPeriod();
  yourEarningsSeries: IChartSerie[] = [];
  yourEarningsData: IChartSerie[] = [];

  yourEarningsAnalyticsItems: AnalyticsCardListItem[] = [];

  sellCoinsService = new SellCoinsService();
  sellCoinsEmpty = false;
  loadingBtnEmptyState: boolean = false;
  welcomeCtaText: string = 'Start Selling';

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get tPrefix() {
    return 'sellCoins';
  }

  get showPurchaseHistory() {
    return (
      this.$store.getters['business/getManagerRole'] === EBusinessUserType.OWNER
    );
  }

  get tOverviewPrefix() {
    return 'sellCoins.overview';
  }

  get tAnalyticsInfoPrefix() {
    return 'sellCoins.revenueReports.yourEarningsSection.analytics.info';
  }

  get showBillingTag() {
    if (!this.flags.includes(flagKeys.billingModuleV2)) return false;
    return (
      !this.loading &&
      this.billingStatus !== EBillingStatusTypes.UNAVAILABLE &&
      !this.showEmptyState
    );
  }

  get businessInfo() {
    return this.$store.getters['business/getBusinessState'] || {};
  }

  get alreadyAccessedSellCoins(): boolean {
    const storage = JSON.parse(
      localStorage.getItem(ALREADY_ACCESSED_SELL_COINS) || '{"value": false}'
    );
    return storage.value && this.businessInfo.id === storage.id;
  }

  get isRemoteLoading() {
    return isRemoteLoading();
  }

  get isShowEmptyState() {
    if (isRemoteLoading()) return false;
    return this.sellCoinsEmpty && !this.alreadyAccessedSellCoins;
  }

  get title() {
    return this.$t(`${this.tPrefix}.revenueReports.title`);
  }

  get description() {
    if (this.showEmptyState || this.loading) {
      return '';
    }
    return this.$t(`${this.tPrefix}.revenueReports.description`);
  }

  get additionalCards(): AnalyticsCardListItem[] {
    return [
      {
        variant: 'white',
        insightVariant: 'regular',
        infos: {
          title: '',
          largeTitle: String(
            this.$t(`${this.tOverviewPrefix}.cards.payout.label`)
          ),
          disableAbbreviateAmount: true,
          amount: getDataOptional(
            this.dashboardData,
            'formatted.payouts.grossPaidTotal',
            '--'
          ),
          tooltipText: String(
            this.$t(`${this.tOverviewPrefix}.cards.payout.tooltip`)
          ),
          insightText: this.payoutInsighStatusMessage,
          counterFractionDigits: 2
        },
        components: {
          rightBottom: {
            text: this.$t(`${this.tOverviewPrefix}.cards.payout.btn`),
            disabled: this.isPayoutHistoryDisabled,
            as: 'Link',
            action: this.onPayoutsHistoryClick,
            class: '--payout-min-size'
          }
        }
      }
    ];
  }

  get payoutInsighStatusMessage(): string {
    if (this.dashboardData) {
      if (this.dashboardData.payouts.netInTransitTotal > 0) {
        return `${
          this.dashboardData.formatted.payouts.netInTransitTotal
        } ${this.$t(`${this.tOverviewPrefix}.cards.payout.insightProcessing`)}`;
      }

      if (this.dashboardData.payouts.last) {
        const formattedDate = DateUtils.formattedDate({
          date: new Date(this.dashboardData.payouts.last.date),
          applyTimezone: true
        });

        return `Last payout:<br />${
          this.dashboardData.formatted.payouts.last.amount
        } on ${formattedDate}`;
      }
    }

    return `${this.$t(`${this.tOverviewPrefix}.cards.payout.insightEmpty`)}`;
  }

  get defaultYourEarningsAnalyticsItems(): AnalyticsCardListItem[] {
    return [
      {
        infos: {
          description: String(
            this.$t(`${this.tAnalyticsInfoPrefix}.totalRevenue.description`)
          ),
          amount: '$0.00',
          tooltipText: String(
            this.$t(`${this.tAnalyticsInfoPrefix}.totalRevenue.tooltip`)
          ),
          tooltipIconPlacement: 'after-title',
          insightText: 'No data available',
          disableAbbreviateAmount: true
        },
        insightVariant: 'normal'
      },
      {
        infos: {
          description: String(
            this.$t(
              `${
                this.tAnalyticsInfoPrefix
              }.avgRevenuePerTransaction.description`
            )
          ),
          amount: '$0.00',
          tooltipText: String(
            this.$t(
              `${this.tAnalyticsInfoPrefix}.avgRevenuePerTransaction.tooltip`
            )
          ),
          tooltipIconPlacement: 'after-title',
          insightText: 'No data available',
          disableAbbreviateAmount: true
        },
        insightVariant: 'normal'
      },
      {
        infos: {
          description: String(
            this.$t(
              `${this.tAnalyticsInfoPrefix}.avgRevenuePerCustomer.description`
            )
          ),
          amount: '$0.00',
          tooltipText: String(
            this.$t(
              `${this.tAnalyticsInfoPrefix}.avgRevenuePerCustomer.tooltip`
            )
          ),
          tooltipIconPlacement: 'after-title',
          insightText: 'No data available',
          disableAbbreviateAmount: true
        },
        insightVariant: 'normal'
      }
    ];
  }

  get isPayoutHistoryDisabled() {
    return !(
      this.dashboardData &&
      this.dashboardData.payouts.netPaidTotal +
        this.dashboardData.payouts.netInTransitTotal >
        0
    );
  }

  onPayoutsHistoryClick() {
    eventBus.$emit(
      'openSubModal',
      new ModalOptions(
        ``,
        ``,
        'none',
        true,
        ``,
        ``,
        ``,
        false,
        `payoutsHistory`,
        false,
        true,
        true,
        true,
        true
      ),
      {
        onConfirm: async () => {}
      }
    );
  }

  async fetchDashboardData() {
    try {
      this.loadingDashboardData = true;
      this.loading = true;
      const { data } = await this.businessWalletService.getDashboard();
      this.dashboardData = data;
    } finally {
      this.loadingDashboardData = false;
      this.loading = false;
    }
  }

  async getCampaignsList() {
    try {
      this.$showLoaderWithLocker();

      const response = await this.sellCoinsService.listOfCampaigns();
      const campaigns = response.data.items;
      this.sellCoinsEmpty =
        campaigns === null || (campaigns && campaigns.length == 0);
    } finally {
      this.loading = false;
      this.$hideLoader();
    }
  }

  get queryParameters() {
    return {
      from: this.yourEarningsPeriod.start,
      to: this.yourEarningsPeriod.end,
      ...(this.yourEarningsPeriod.shortcut && {
        slug:
          PerformanceUtils.datepickerShortcutMapper[
            this.yourEarningsPeriod.shortcut as DatePickerShortcut
          ]
      })
    };
  }

  async loadYourEarnings() {
    try {
      this.yourEarningsLoading = true;
      const allGraphs: any[] = [];
      const graphs = Object.values(earningsGraphsOptions);

      graphs.forEach((item: any, index: number) => {
        allGraphs[index] = {
          ...PerformanceUtils.normalizedChartSeries(
            {
              labels: [],
              datasets: [item]
            },
            false,
            this.yourEarningsPeriod.shortcut !== EPeriodPerformance.WEEK
          )[0],
          loaded: false
        };

        this.yourEarningsSeries = allGraphs;
        this.businessWalletService
          .getYourEarnings({
            ...this.queryParameters,
            groupBy: item.slug
          })
          .then(({ data }) => {
            const normalizedData = this.businessWalletService.normalizeEarningsData(
              data,
              item.label,
              item.slug
            );

            this.yourEarningsSeries[index] = {
              ...PerformanceUtils.normalizedChartSeries(
                {
                  ...normalizedData,
                  datasets: [normalizedData.datasets]
                },
                true,
                this.yourEarningsPeriod.shortcut !== EPeriodPerformance.WEEK
              )[0],
              loaded: true
            };

            this.yourEarningsSeries = [...this.yourEarningsSeries];

            this.yourEarningsData = JSON.parse(
              JSON.stringify(this.yourEarningsSeries)
            );

            if (item.slug === EYourEarningsGroupByOption.OVERTIME) {
              this.updateAnalyticsItems(normalizedData);
            }
          });
      });
    } finally {
      this.yourEarningsLoading = false;
      this.yourEarningsFirstLoading = false;
    }
  }

  handleYourEarningsPeriodChange(period: IPeriod) {
    this.yourEarningsPeriod = PerformanceUtils.normalizedPeriod(period);
    segmentIo.track('Your Earnings Filtered', {
      Field: 'period',
      Value: period
    });
    this.loadYourEarnings();
  }

  formatMoneyWithAbbreviation(number: number, fractionDigits: number = 2) {
    return `$${abbreviateNumber(number, fractionDigits)}`;
  }

  updateAnalyticsItems(data: any) {
    if (!data) return;

    const calculatePercentage = (current: number, past: number) => {
      if (!past) return 0;
      return Math.round(((current - past) / past) * 100);
    };

    const getArrowDirection = (percentage: number) => {
      if (percentage > 0) return EAnalyticsCardArrowDirection.UP;
      if (percentage < 0) return EAnalyticsCardArrowDirection.DOWN;
      return undefined;
    };

    const getVariant = (percentage: number) => {
      if (percentage > 0) return 'success';
      if (percentage < 0) return 'danger';
      return 'normal';
    };

    const totalRevenue = data.totalRevenueGenerated || { current: 0, past: 0 };
    const avgTransaction = data.averageRevenuePerTransaction || {
      current: 0,
      past: 0
    };
    const avgCustomer = data.averageRevenuePerCustomer || {
      current: 0,
      past: 0
    };

    const totalRevenuePercentage = calculatePercentage(
      totalRevenue.current,
      totalRevenue.past
    );
    const avgTransactionPercentage = calculatePercentage(
      avgTransaction.current,
      avgTransaction.past
    );
    const avgCustomerPercentage = calculatePercentage(
      avgCustomer.current,
      avgCustomer.past
    );

    this.yourEarningsAnalyticsItems = [
      {
        infos: {
          description: String(
            this.$t(`${this.tAnalyticsInfoPrefix}.totalRevenue.description`)
          ),
          amount: this.formatMoneyWithAbbreviation(totalRevenue.current),
          tooltipText: String(
            this.$t(`${this.tAnalyticsInfoPrefix}.totalRevenue.tooltip`)
          ),
          tooltipIconPlacement: 'after-title',
          insightText: this.yourEarningsPeriod.shortcut
            ? `${Math.abs(
                totalRevenuePercentage
              )}% ${PerformanceUtils.getComparativeLabel(this.yourEarningsPeriod
                .shortcut as DatePickerShortcut)}`
            : '',
          arrowDirection: getArrowDirection(totalRevenuePercentage),
          disableAbbreviateAmount: true
        },
        insightVariant: getVariant(totalRevenuePercentage)
      },
      {
        infos: {
          description: String(
            this.$t(
              `${
                this.tAnalyticsInfoPrefix
              }.avgRevenuePerTransaction.description`
            )
          ),
          amount: this.formatMoneyWithAbbreviation(avgTransaction.current),
          tooltipText: String(
            this.$t(
              `${this.tAnalyticsInfoPrefix}.avgRevenuePerTransaction.tooltip`
            )
          ),
          tooltipIconPlacement: 'after-title',
          insightText: this.yourEarningsPeriod.shortcut
            ? `${Math.abs(
                avgTransactionPercentage
              )}% ${PerformanceUtils.getComparativeLabel(this.yourEarningsPeriod
                .shortcut as DatePickerShortcut)}`
            : '',
          arrowDirection: getArrowDirection(avgTransactionPercentage),
          disableAbbreviateAmount: true
        },
        insightVariant: getVariant(avgTransactionPercentage)
      },
      {
        infos: {
          description: String(
            this.$t(
              `${this.tAnalyticsInfoPrefix}.avgRevenuePerCustomer.description`
            )
          ),
          amount: this.formatMoneyWithAbbreviation(avgCustomer.current),
          tooltipText: String(
            this.$t(
              `${this.tAnalyticsInfoPrefix}.avgRevenuePerCustomer.tooltip`
            )
          ),
          tooltipIconPlacement: 'after-title',
          insightText: this.yourEarningsPeriod.shortcut
            ? `${Math.abs(
                avgCustomerPercentage
              )}% ${PerformanceUtils.getComparativeLabel(this.yourEarningsPeriod
                .shortcut as DatePickerShortcut)}`
            : '',
          arrowDirection: getArrowDirection(avgCustomerPercentage),
          disableAbbreviateAmount: true
        },
        insightVariant: getVariant(avgCustomerPercentage)
      }
    ];
  }

  setAccessedEmptyState() {
    this.showEmptyState = false;
    const businessInfo = this.$store.getters['business/getBusinessState'] || {};
    localStorage.setItem(
      ALREADY_ACCESSED_SELL_COINS,
      JSON.stringify({
        value: true,
        id: businessInfo.id
      })
    );
  }

  async setUpRevenueReports() {
    try {
      if (this.inactiveBilling) {
        this.loadingBtnEmptyState = true;
      }

      const result = await setUpSellCoins({
        inactiveBilling: this.inactiveBilling,
        managerRole: this.$store.getters['business/getManagerRole'],
        notification: this.$notification,
        welcomeCtaText: this.welcomeCtaText,
        setAccessedEmptyState: () => this.setAccessedEmptyState()
      });

      if (!this.inactiveBilling && result) {
        this.showEmptyState = false;
        this.setAccessedEmptyState();
      }
    } finally {
      if (this.inactiveBilling) {
        this.loadingBtnEmptyState = false;
      }
    }
  }

  created() {
    this.yourEarningsAnalyticsItems = this.defaultYourEarningsAnalyticsItems;
    this.fetchDashboardData();
    this.loadYourEarnings();
  }

  mounted() {
    this.getCampaignsList();
  }
}
